'use strict';

var React = require('react'),
    IconMixin = require('../../mixins/IconMixin');

var VideoIcon = React.createClass({
  mixins: [IconMixin],

  renderSVG: function (size) {
    switch (size) {
    case 'small':
      return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M17 4l-5 3V4c0-0.55-0.45-1-1-1H2C1.45 3 1 3.45 1 4v10c0 0.55 0.45 1 1 1h9c0.55 0 1-0.45 1-1v-2.97L17 14V4z"/>';
    case 'medium':
      return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M31 6.88L22 12V7c0-1.03-0.96-2-2-2L2.88 5C1.84 5 1 5.84 1 6.88v18.25C1 26.16 1.84 27 2.88 27H20c1.03 0 2-0.96 2-2v-5l9 5.13V6.88z"/>';
    case 'large':
      return '<path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M46.5 10.33L32.5 19v-8.67c0-1.56-1.32-2.83-2.87-2.83H4.31C2.76 7.5 1.5 8.77 1.5 10.33v28.33c0 1.57 1.26 2.83 2.81 2.83h25.31c1.55 0 2.88-1.27 2.88-2.83V30l14 8.67V10.33z"/>';
    }
  }
});

module.exports = VideoIcon;



/** WEBPACK FOOTER **
 ** ./atoms/icons/Video.jsx
 **/